var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdropmobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 765,
    height: 14611,
    viewBox: "0 0 765 14611",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_941_29",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 765,
    height: 14611
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M765 0H0V14611H765V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_941_29)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1188.83 2608.36C1204.04 2644.52 1092.72 2725.84 940.184 2790C787.652 2854.16 651.672 2876.87 636.465 2840.72C621.257 2804.56 732.581 2723.24 885.114 2659.08C1037.65 2594.92 1173.63 2572.21 1188.83 2608.36Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1021.83 6744.46C1037.04 6780.61 925.717 6861.93 773.184 6926.1C620.652 6990.26 484.672 7012.96 469.465 6976.81C454.257 6940.66 565.581 6859.34 718.114 6795.17C870.646 6731.01 1006.63 6708.31 1021.83 6744.46Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.6096 11434.5C-102.818 11470.6 8.50639 11551.9 161.039 11616.1C313.571 11680.3 449.551 11703 464.758 11666.8C479.966 11630.7 368.642 11549.3 216.109 11485.2C63.5774 11421 -72.4026 11398.3 -87.6096 11434.5Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.5 2037C268.469 2037 326 1987.3 326 1926C326 1864.7 268.469 1815 197.5 1815C126.531 1815 69 1864.7 69 1926C69 1987.3 126.531 2037 197.5 2037Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.5 351C232.469 351 290 301.304 290 240C290 178.696 232.469 129 161.5 129C90.5314 129 33 178.696 33 240C33 301.304 90.5314 351 161.5 351Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M817 3966C870.019 3966 913 3928.84 913 3883C913 3837.16 870.019 3800 817 3800C763.981 3800 721 3837.16 721 3883C721 3928.84 763.981 3966 817 3966Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650 8102.1C703.019 8102.1 746 8064.94 746 8019.1C746 7973.26 703.019 7936.1 650 7936.1C596.981 7936.1 554 7973.26 554 8019.1C554 8064.94 596.981 8102.1 650 8102.1Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287 13104C233.981 13104 191 13066.8 191 13021C191 12975.2 233.981 12938 287 12938C340.019 12938 383 12975.2 383 13021C383 13066.8 340.019 13104 287 13104Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 4810C140.692 4810 198 4750.45 198 4677C198 4603.55 140.692 4544 70 4544C-0.692451 4544 -58 4603.55 -58 4677C-58 4750.45 -0.692451 4810 70 4810Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M864.223 9500C793.53 9500 736.223 9440.45 736.223 9367C736.223 9293.55 793.53 9234 864.223 9234C934.915 9234 992.223 9293.55 992.223 9367C992.223 9440.45 934.915 9500 864.223 9500Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-97 8946.09C-26.3076 8946.09 31 8886.54 31 8813.09C31 8739.64 -26.3076 8680.09 -97 8680.09C-167.692 8680.09 -225 8739.64 -225 8813.09C-225 8886.54 -167.692 8946.09 -97 8946.09Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_941_29)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.801 9433.27C995.775 9464.61 1099.14 9458.14 1109.68 9418.81C1120.22 9379.48 1033.94 9322.19 916.962 9290.85C799.987 9259.51 696.619 9265.98 686.081 9305.31C675.543 9344.63 761.827 9401.93 878.801 9433.27Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.47 5724.73C922.234 5691.56 1014.57 5634.85 1004.71 5598.04C994.849 5561.24 886.524 5558.29 762.76 5591.45C638.996 5624.62 546.659 5681.33 556.52 5718.14C566.381 5754.94 674.706 5757.89 798.47 5724.73Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.094 10520.3C381.33 10487.2 288.994 10430.4 298.855 10393.6C308.716 10356.8 417.04 10353.9 540.805 10387C664.569 10420.2 756.905 10476.9 747.044 10513.7C737.183 10550.5 628.859 10553.5 505.094 10520.3Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_941_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.094 14134.3C241.33 14101.2 148.993 14044.4 158.855 14007.6C168.716 13970.8 277.04 13967.9 400.805 14001C524.569 14034.2 616.905 14090.9 607.044 14127.7C597.183 14164.5 488.859 14167.5 365.094 14134.3Z",
    fill: "#88FCAF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_941_29)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_941_29",
    x: 166.275,
    y: 2122.37,
    width: 1492.75,
    height: 1204.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_941_29",
    x: -0.724792,
    y: 6258.46,
    width: 1492.75,
    height: 1204.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_941_29",
    x: -557.8,
    y: 10948.5,
    width: 1492.75,
    height: 1204.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_941_29",
    x: -399.8,
    y: 1346.2,
    width: 1194.6,
    height: 1159.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_941_29",
    x: -435.8,
    y: -339.8,
    width: 1194.6,
    height: 1159.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_941_29",
    x: 252.2,
    y: 3331.2,
    width: 1129.6,
    height: 1103.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_941_29",
    x: 85.2,
    y: 7467.3,
    width: 1129.6,
    height: 1103.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_941_29",
    x: -277.8,
    y: 12469.2,
    width: 1129.6,
    height: 1103.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_941_29",
    x: -526.8,
    y: 4075.2,
    width: 1193.6,
    height: 1203.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_941_29",
    x: 267.423,
    y: 8765.2,
    width: 1193.6,
    height: 1203.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_941_29",
    x: -693.8,
    y: 8211.29,
    width: 1193.6,
    height: 1203.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_941_29",
    x: 383.409,
    y: 4666.1,
    width: 1362.94,
    height: 1119.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_941_29",
    x: 216.41,
    y: 8802.2,
    width: 1362.94,
    height: 1119.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_941_29",
    x: 86.9988,
    y: 5099.59,
    width: 1387.23,
    height: 1117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_941_29",
    x: -170.667,
    y: 9895.18,
    width: 1387.23,
    height: 1117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_941_29",
    x: -310.667,
    y: 13509.2,
    width: 1387.23,
    height: 1117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_941_29",
    x: 424.2,
    y: 506.2,
    width: 1197.6,
    height: 1161.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.4,
    result: "effect1_foregroundBlur_941_29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 765,
    height: 14611,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropmobile);
export default __webpack_public_path__ + "static/media/backdropmobile.b92645aadb9b2dfd1b5745b416d723dd.svg";
export { ForwardRef as ReactComponent };